import React from "react";
import { Heart, Camera, Sparkles, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-8 py-16" data-testid="about-root">
      <div className="text-center">
        <div className="eyebrow">Sobre a Eterniza Imãs</div>
        <h1 className="mt-2 font-display text-5xl text-[#0D1B2A]">
          Presentes que <em className="font-script text-[#D4AF37] not-italic">eternizam histórias</em>
        </h1>
        <p className="mt-6 text-[#3A4A5F] text-lg leading-relaxed max-w-2xl mx-auto">
          Somos uma pequena empresa apaixonada por transformar momentos em lembranças físicas, para que
          nenhuma memória se perca no digital. Cada peça é impressa e montada com carinho, feita para durar.
        </p>
      </div>

      <div className="mt-16 grid md:grid-cols-2 gap-6">
        {[
          [Heart, "Feito com amor", "Cada peça é única e produzida com atenção total aos detalhes."],
          [Camera, "Qualidade Premium", "Materiais nobres, impressão fotográfica de alta resolução."],
          [Sparkles, "Personalização Total", "Suas fotos, suas histórias, do seu jeito."],
          [ShieldCheck, "Confiança & Segurança", "Envios para todo o Brasil e pagamento seguro."],
        ].map(([I, t, s], i) => (
          <div key={i} className="bg-white rounded-2xl p-6 border border-[#0D1B2A]/5 lift flex gap-4">
            <div className="w-12 h-12 rounded-full bg-[#F7F2E7] flex items-center justify-center shrink-0">
              <I size={20} className="text-[#0D1B2A]" />
            </div>
            <div>
              <div className="font-display text-xl text-[#0D1B2A]">{t}</div>
              <p className="text-sm text-[#6B7280] mt-1">{s}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
